// Do not edit manually!
// This file is automatically generated by importWebIconsFromFigma.ts script.

import type {SvgAsset} from '*.svg';

type SvgAssetMapSchema = Record<string, any>;

export type SvgAssetMap<T extends SvgAssetMapSchema> = {[K in keyof T]: SvgAsset};

// Identity function used to add types to icons, since the result of require('...') is
// typed as "any."
function buildSvgAssetMap<T extends SvgAssetMapSchema>(schema: T): SvgAssetMap<T> {
  return schema;
}

/* eslint-disable @typescript-eslint/no-require-imports */
export const webIcons = buildSvgAssetMap({
  'add-link/outlined/16': require('./add-link/add-link-outlined-16.svg'),
  'add-reaction/outlined/16': require('./add-reaction/add-reaction-outlined-16.svg'),
  'adjust-tone/outlined/12': require('./adjust-tone/adjust-tone-outlined-12.svg'),
  'adjust-tone/outlined/16': require('./adjust-tone/adjust-tone-outlined-16.svg'),
  'ai-agent/filled/16': require('./ai-agent/ai-agent-filled-16.svg'),
  'ai-agent/outlined/16': require('./ai-agent/ai-agent-outlined-16.svg'),
  'ai-compose/outlined/16': require('./ai-compose/ai-compose-outlined-16.svg'),
  'ai-compose/outlined/20': require('./ai-compose/ai-compose-outlined-20.svg'),
  'ai-summary/outlined/16': require('./ai-summary/ai-summary-outlined-16.svg'),
  'ai/gradient/16': require('./ai/ai-gradient-16.svg'),
  'ai/gradient/20': require('./ai/ai-gradient-20.svg'),
  'ai/gradient/32': require('./ai/ai-gradient-32.svg'),
  'alarm-clock/filled/12': require('./alarm-clock/alarm-clock-filled-12.svg'),
  'alarm-clock/filled/16': require('./alarm-clock/alarm-clock-filled-16.svg'),
  'alarm-clock/filled/20': require('./alarm-clock/alarm-clock-filled-20.svg'),
  'alarm-clock/outlined/12': require('./alarm-clock/alarm-clock-outlined-12.svg'),
  'alarm-clock/outlined/16': require('./alarm-clock/alarm-clock-outlined-16.svg'),
  'alarm-clock/outlined/20': require('./alarm-clock/alarm-clock-outlined-20.svg'),
  'alert-circle/filled/16': require('./alert-circle/alert-circle-filled-16.svg'),
  'alert-circle/outlined/16': require('./alert-circle/alert-circle-outlined-16.svg'),
  'alert-hexagon/filled/16': require('./alert-hexagon/alert-hexagon-filled-16.svg'),
  'alert-hexagon/filled/20': require('./alert-hexagon/alert-hexagon-filled-20.svg'),
  'alert-hexagon/outlined/16': require('./alert-hexagon/alert-hexagon-outlined-16.svg'),
  'alert-hexagon/outlined/20': require('./alert-hexagon/alert-hexagon-outlined-20.svg'),
  'alert-square/outlined/16': require('./alert-square/alert-square-outlined-16.svg'),
  'alert-triangle/filled/12': require('./alert-triangle/alert-triangle-filled-12.svg'),
  'alert-triangle/filled/16': require('./alert-triangle/alert-triangle-filled-16.svg'),
  'alert-triangle/filled/20': require('./alert-triangle/alert-triangle-filled-20.svg'),
  'alert-triangle/outlined/12': require('./alert-triangle/alert-triangle-outlined-12.svg'),
  'alert-triangle/outlined/16': require('./alert-triangle/alert-triangle-outlined-16.svg'),
  'alert-triangle/outlined/20': require('./alert-triangle/alert-triangle-outlined-20.svg'),
  'align-left/outlined/12': require('./align-left/align-left-outlined-12.svg'),
  'align-left/outlined/16': require('./align-left/align-left-outlined-16.svg'),
  'align-left/outlined/20': require('./align-left/align-left-outlined-20.svg'),
  'align-vertical-center/outlined/16': require('./align-vertical-center/align-vertical-center-outlined-16.svg'),
  'archive-off/filled/12': require('./archive-off/archive-off-filled-12.svg'),
  'archive-off/filled/16': require('./archive-off/archive-off-filled-16.svg'),
  'archive-off/filled/20': require('./archive-off/archive-off-filled-20.svg'),
  'archive-off/outlined/12': require('./archive-off/archive-off-outlined-12.svg'),
  'archive/filled/12': require('./archive/archive-filled-12.svg'),
  'archive/filled/16': require('./archive/archive-filled-16.svg'),
  'archive/filled/20': require('./archive/archive-filled-20.svg'),
  'archive/outlined/12': require('./archive/archive-outlined-12.svg'),
  'archive/outlined/16': require('./archive/archive-outlined-16.svg'),
  'archive/outlined/20': require('./archive/archive-outlined-20.svg'),
  'arrow-block-right/filled/12': require('./arrow-block-right/arrow-block-right-filled-12.svg'),
  'arrow-block-right/filled/16': require('./arrow-block-right/arrow-block-right-filled-16.svg'),
  'arrow-block-right/filled/20': require('./arrow-block-right/arrow-block-right-filled-20.svg'),
  'arrow-block-right/outlined/12': require('./arrow-block-right/arrow-block-right-outlined-12.svg'),
  'arrow-block-right/outlined/16': require('./arrow-block-right/arrow-block-right-outlined-16.svg'),
  'arrow-block-right/outlined/20': require('./arrow-block-right/arrow-block-right-outlined-20.svg'),
  'arrow-circle-broken-right/filled/16': require('./arrow-circle-broken-right/arrow-circle-broken-right-filled-16.svg'),
  'arrow-narrow-down-right/outlined/16': require('./arrow-narrow-down-right/arrow-narrow-down-right-outlined-16.svg'),
  'arrow-narrow-down/filled/16': require('./arrow-narrow-down/arrow-narrow-down-filled-16.svg'),
  'arrow-narrow-down/outlined/12': require('./arrow-narrow-down/arrow-narrow-down-outlined-12.svg'),
  'arrow-narrow-down/outlined/16': require('./arrow-narrow-down/arrow-narrow-down-outlined-16.svg'),
  'arrow-narrow-left/filled/16': require('./arrow-narrow-left/arrow-narrow-left-filled-16.svg'),
  'arrow-narrow-left/outlined/16': require('./arrow-narrow-left/arrow-narrow-left-outlined-16.svg'),
  'arrow-narrow-right/filled/12': require('./arrow-narrow-right/arrow-narrow-right-filled-12.svg'),
  'arrow-narrow-right/filled/16': require('./arrow-narrow-right/arrow-narrow-right-filled-16.svg'),
  'arrow-narrow-right/filled/20': require('./arrow-narrow-right/arrow-narrow-right-filled-20.svg'),
  'arrow-narrow-right/outlined/12': require('./arrow-narrow-right/arrow-narrow-right-outlined-12.svg'),
  'arrow-narrow-right/outlined/16': require('./arrow-narrow-right/arrow-narrow-right-outlined-16.svg'),
  'arrow-narrow-right/outlined/20': require('./arrow-narrow-right/arrow-narrow-right-outlined-20.svg'),
  'arrow-narrow-up-right/outlined/16': require('./arrow-narrow-up-right/arrow-narrow-up-right-outlined-16.svg'),
  'arrow-narrow-up/filled/16': require('./arrow-narrow-up/arrow-narrow-up-filled-16.svg'),
  'arrow-narrow-up/outlined/12': require('./arrow-narrow-up/arrow-narrow-up-outlined-12.svg'),
  'arrow-narrow-up/outlined/16': require('./arrow-narrow-up/arrow-narrow-up-outlined-16.svg'),
  'arrow-narrow-up/outlined/20': require('./arrow-narrow-up/arrow-narrow-up-outlined-20.svg'),
  'at-sign/filled/16': require('./at-sign/at-sign-filled-16.svg'),
  'at-sign/outlined/16': require('./at-sign/at-sign-outlined-16.svg'),
  'at-sign/outlined/20': require('./at-sign/at-sign-outlined-20.svg'),
  'audit-log/filled/16': require('./audit-log/audit-log-filled-16.svg'),
  'audit-log/outlined/12': require('./audit-log/audit-log-outlined-12.svg'),
  'audit-log/outlined/16': require('./audit-log/audit-log-outlined-16.svg'),
  'audit-log/outlined/20': require('./audit-log/audit-log-outlined-20.svg'),
  'autopilot/filled/20': require('./autopilot/autopilot-filled-20.svg'),
  'autopilot/outlined/16': require('./autopilot/autopilot-outlined-16.svg'),
  'autopilot/outlined/20': require('./autopilot/autopilot-outlined-20.svg'),
  'bar-chart-01/filled/16': require('./bar-chart-01/bar-chart-01-filled-16.svg'),
  'bar-chart-01/filled/20': require('./bar-chart-01/bar-chart-01-filled-20.svg'),
  'bar-chart-01/outlined/16': require('./bar-chart-01/bar-chart-01-outlined-16.svg'),
  'bar-chart-01/outlined/20': require('./bar-chart-01/bar-chart-01-outlined-20.svg'),
  'bar-chart-10/filled/16': require('./bar-chart-10/bar-chart-10-filled-16.svg'),
  'bar-chart-10/outlined/16': require('./bar-chart-10/bar-chart-10-outlined-16.svg'),
  'bar-chart-10/outlined/20': require('./bar-chart-10/bar-chart-10-outlined-20.svg'),
  'bell-01/filled/12': require('./bell-01/bell-01-filled-12.svg'),
  'bell-01/filled/16': require('./bell-01/bell-01-filled-16.svg'),
  'bell-01/filled/20': require('./bell-01/bell-01-filled-20.svg'),
  'bell-01/outlined/12': require('./bell-01/bell-01-outlined-12.svg'),
  'bell-01/outlined/16': require('./bell-01/bell-01-outlined-16.svg'),
  'bell-01/outlined/20': require('./bell-01/bell-01-outlined-20.svg'),
  'bell-off-01/filled/16': require('./bell-off-01/bell-off-01-filled-16.svg'),
  'bell-off-01/filled/20': require('./bell-off-01/bell-off-01-filled-20.svg'),
  'bell-off-01/outlined/12': require('./bell-off-01/bell-off-01-outlined-12.svg'),
  'bell-off-01/outlined/16': require('./bell-off-01/bell-off-01-outlined-16.svg'),
  'bell-off-01/outlined/20': require('./bell-off-01/bell-off-01-outlined-20.svg'),
  'bold-01/outlined/16': require('./bold-01/bold-01-outlined-16.svg'),
  'bold-01/outlined/20': require('./bold-01/bold-01-outlined-20.svg'),
  'book-closed/outlined/16': require('./book-closed/book-closed-outlined-16.svg'),
  'book-closed/outlined/20': require('./book-closed/book-closed-outlined-20.svg'),
  'book-open-01/filled/16': require('./book-open-01/book-open-01-filled-16.svg'),
  'book-open-01/filled/20': require('./book-open-01/book-open-01-filled-20.svg'),
  'book-open-01/outlined/12': require('./book-open-01/book-open-01-outlined-12.svg'),
  'book-open-01/outlined/16': require('./book-open-01/book-open-01-outlined-16.svg'),
  'book-open-01/outlined/20': require('./book-open-01/book-open-01-outlined-20.svg'),
  'brackets-ellipses/filled/16': require('./brackets-ellipses/brackets-ellipses-filled-16.svg'),
  'brackets-ellipses/filled/20': require('./brackets-ellipses/brackets-ellipses-filled-20.svg'),
  'brackets-ellipses/outlined/16': require('./brackets-ellipses/brackets-ellipses-outlined-16.svg'),
  'brackets-ellipses/outlined/20': require('./brackets-ellipses/brackets-ellipses-outlined-20.svg'),
  'branching-rule/filled/16': require('./branching-rule/branching-rule-filled-16.svg'),
  'branching-rule/filled/20': require('./branching-rule/branching-rule-filled-20.svg'),
  'branching-rule/outlined/16': require('./branching-rule/branching-rule-outlined-16.svg'),
  'briefcase-01-plus/outlined/16': require('./briefcase-01-plus/briefcase-01-plus-outlined-16.svg'),
  'briefcase-01/filled/16': require('./briefcase-01/briefcase-01-filled-16.svg'),
  'briefcase-01/filled/20': require('./briefcase-01/briefcase-01-filled-20.svg'),
  'briefcase-01/outlined/12': require('./briefcase-01/briefcase-01-outlined-12.svg'),
  'briefcase-01/outlined/16': require('./briefcase-01/briefcase-01-outlined-16.svg'),
  'briefcase-01/outlined/20': require('./briefcase-01/briefcase-01-outlined-20.svg'),
  'building-05/filled/16': require('./building-05/building-05-filled-16.svg'),
  'building-05/filled/20': require('./building-05/building-05-filled-20.svg'),
  'building-05/outlined/16': require('./building-05/building-05-outlined-16.svg'),
  'building-05/outlined/20': require('./building-05/building-05-outlined-20.svg'),
  'business-hours/filled/20': require('./business-hours/business-hours-filled-20.svg'),
  'calendar-check-02/filled/16': require('./calendar-check-02/calendar-check-02-filled-16.svg'),
  'calendar-check-02/filled/20': require('./calendar-check-02/calendar-check-02-filled-20.svg'),
  'calendar-check-02/outlined/16': require('./calendar-check-02/calendar-check-02-outlined-16.svg'),
  'calendar-check-02/outlined/20': require('./calendar-check-02/calendar-check-02-outlined-20.svg'),
  'calendar-plus-02/outlined/20': require('./calendar-plus-02/calendar-plus-02-outlined-20.svg'),
  'calendar/filled/16': require('./calendar/calendar-filled-16.svg'),
  'calendar/filled/20': require('./calendar/calendar-filled-20.svg'),
  'calendar/outlined/12': require('./calendar/calendar-outlined-12.svg'),
  'calendar/outlined/16': require('./calendar/calendar-outlined-16.svg'),
  'calendar/outlined/20': require('./calendar/calendar-outlined-20.svg'),
  'caret-collapse/outlined/12': require('./caret-collapse/caret-collapse-outlined-12.svg'),
  'caret-collapse/outlined/16': require('./caret-collapse/caret-collapse-outlined-16.svg'),
  'caret-expand/outlined/12': require('./caret-expand/caret-expand-outlined-12.svg'),
  'caret-expand/outlined/16': require('./caret-expand/caret-expand-outlined-16.svg'),
  'chat-ended-activity/outlined/12': require('./chat-ended-activity/chat-ended-activity-outlined-12.svg'),
  'chat/filled/16': require('./chat/chat-filled-16.svg'),
  'chat/filled/20': require('./chat/chat-filled-20.svg'),
  'chat/outlined/12': require('./chat/chat-outlined-12.svg'),
  'chat/outlined/16': require('./chat/chat-outlined-16.svg'),
  'chat/outlined/20': require('./chat/chat-outlined-20.svg'),
  'check-circle/filled/12': require('./check-circle/check-circle-filled-12.svg'),
  'check-circle/filled/16': require('./check-circle/check-circle-filled-16.svg'),
  'check-circle/filled/20': require('./check-circle/check-circle-filled-20.svg'),
  'check-circle/outlined/16': require('./check-circle/check-circle-outlined-16.svg'),
  'check-circle/outlined/20': require('./check-circle/check-circle-outlined-20.svg'),
  'check-verified-02/filled/16': require('./check-verified-02/check-verified-02-filled-16.svg'),
  'check-verified-02/filled/20': require('./check-verified-02/check-verified-02-filled-20.svg'),
  'check-verified-02/outlined/16': require('./check-verified-02/check-verified-02-outlined-16.svg'),
  'check/outlined/12': require('./check/check-outlined-12.svg'),
  'check/outlined/16': require('./check/check-outlined-16.svg'),
  'check/outlined/20': require('./check/check-outlined-20.svg'),
  'chevron-down/outlined/12': require('./chevron-down/chevron-down-outlined-12.svg'),
  'chevron-down/outlined/16': require('./chevron-down/chevron-down-outlined-16.svg'),
  'chevron-down/outlined/20': require('./chevron-down/chevron-down-outlined-20.svg'),
  'chevron-left/outlined/16': require('./chevron-left/chevron-left-outlined-16.svg'),
  'chevron-left/outlined/20': require('./chevron-left/chevron-left-outlined-20.svg'),
  'chevron-right/outlined/12': require('./chevron-right/chevron-right-outlined-12.svg'),
  'chevron-right/outlined/16': require('./chevron-right/chevron-right-outlined-16.svg'),
  'chevron-right/outlined/20': require('./chevron-right/chevron-right-outlined-20.svg'),
  'chevron-up/outlined/16': require('./chevron-up/chevron-up-outlined-16.svg'),
  'circle/filled/16': require('./circle/circle-filled-16.svg'),
  'clock-check/outlined/16': require('./clock-check/clock-check-outlined-16.svg'),
  'clock-rewind/outlined/16': require('./clock-rewind/clock-rewind-outlined-16.svg'),
  'clock-rewind/outlined/20': require('./clock-rewind/clock-rewind-outlined-20.svg'),
  'clock-snooze/filled/16': require('./clock-snooze/clock-snooze-filled-16.svg'),
  'clock-snooze/outlined/20': require('./clock-snooze/clock-snooze-outlined-20.svg'),
  'clock/filled/12': require('./clock/clock-filled-12.svg'),
  'clock/filled/16': require('./clock/clock-filled-16.svg'),
  'clock/filled/20': require('./clock/clock-filled-20.svg'),
  'clock/outlined/12': require('./clock/clock-outlined-12.svg'),
  'clock/outlined/16': require('./clock/clock-outlined-16.svg'),
  'clock/outlined/20': require('./clock/clock-outlined-20.svg'),
  'cloud-off/filled/16': require('./cloud-off/cloud-off-filled-16.svg'),
  'cloud-off/filled/20': require('./cloud-off/cloud-off-filled-20.svg'),
  'code-01/filled/16': require('./code-01/code-01-filled-16.svg'),
  'code-01/outlined/16': require('./code-01/code-01-outlined-16.svg'),
  'code-01/outlined/20': require('./code-01/code-01-outlined-20.svg'),
  'connectors/filled/16': require('./connectors/connectors-filled-16.svg'),
  'contact-auto/filled/12': require('./contact-auto/contact-auto-filled-12.svg'),
  'contact-auto/filled/16': require('./contact-auto/contact-auto-filled-16.svg'),
  'contact-auto/outlined/16': require('./contact-auto/contact-auto-outlined-16.svg'),
  'contrast-02/filled/12': require('./contrast-02/contrast-02-filled-12.svg'),
  'contrast-02/outlined/12': require('./contrast-02/contrast-02-outlined-12.svg'),
  'contrast-02/outlined/16': require('./contrast-02/contrast-02-outlined-16.svg'),
  'contrast-02/outlined/20': require('./contrast-02/contrast-02-outlined-20.svg'),
  'conversation-search/outlined/20': require('./conversation-search/conversation-search-outlined-20.svg'),
  'conversation/outlined/12': require('./conversation/conversation-outlined-12.svg'),
  'conversation/outlined/16': require('./conversation/conversation-outlined-16.svg'),
  'copilot/outlined/16': require('./copilot/copilot-outlined-16.svg'),
  'copy-06/outlined/12': require('./copy-06/copy-06-outlined-12.svg'),
  'copy-06/outlined/16': require('./copy-06/copy-06-outlined-16.svg'),
  'copy-file/filled/16': require('./copy-file/copy-file-filled-16.svg'),
  'copy-file/outlined/20': require('./copy-file/copy-file-outlined-20.svg'),
  'corner-down-right/outlined/12': require('./corner-down-right/corner-down-right-outlined-12.svg'),
  'corner-down-right/outlined/16': require('./corner-down-right/corner-down-right-outlined-16.svg'),
  'corner-down-right/outlined/20': require('./corner-down-right/corner-down-right-outlined-20.svg'),
  'corner-up-left-double/outlined/16': require('./corner-up-left-double/corner-up-left-double-outlined-16.svg'),
  'corner-up-left-double/outlined/20': require('./corner-up-left-double/corner-up-left-double-outlined-20.svg'),
  'corner-up-left/filled/16': require('./corner-up-left/corner-up-left-filled-16.svg'),
  'corner-up-left/filled/20': require('./corner-up-left/corner-up-left-filled-20.svg'),
  'corner-up-left/outlined/12': require('./corner-up-left/corner-up-left-outlined-12.svg'),
  'corner-up-left/outlined/16': require('./corner-up-left/corner-up-left-outlined-16.svg'),
  'corner-up-left/outlined/20': require('./corner-up-left/corner-up-left-outlined-20.svg'),
  'corner-up-right/filled/20': require('./corner-up-right/corner-up-right-filled-20.svg'),
  'corner-up-right/outlined/16': require('./corner-up-right/corner-up-right-outlined-16.svg'),
  'corner-up-right/outlined/20': require('./corner-up-right/corner-up-right-outlined-20.svg'),
  'credit-card-02/filled/16': require('./credit-card-02/credit-card-02-filled-16.svg'),
  'credit-card-02/outlined/16': require('./credit-card-02/credit-card-02-outlined-16.svg'),
  'crown/filled/16': require('./crown/crown-filled-16.svg'),
  'cube-01-off/outlined/12': require('./cube-01-off/cube-01-off-outlined-12.svg'),
  'cube-01-off/outlined/16': require('./cube-01-off/cube-01-off-outlined-16.svg'),
  'cube-01-off/outlined/20': require('./cube-01-off/cube-01-off-outlined-20.svg'),
  'cube-01/filled/16': require('./cube-01/cube-01-filled-16.svg'),
  'cube-01/filled/20': require('./cube-01/cube-01-filled-20.svg'),
  'cube-01/outlined/12': require('./cube-01/cube-01-outlined-12.svg'),
  'cube-01/outlined/16': require('./cube-01/cube-01-outlined-16.svg'),
  'cube-01/outlined/20': require('./cube-01/cube-01-outlined-20.svg'),
  'cube-outline/outlined/12': require('./cube-outline/cube-outline-outlined-12.svg'),
  'cursor-click/filled/16': require('./cursor-click/cursor-click-filled-16.svg'),
  'customer-portal/filled/16': require('./customer-portal/customer-portal-filled-16.svg'),
  'customer-portal/filled/20': require('./customer-portal/customer-portal-filled-20.svg'),
  'customer-portal/outlined/16': require('./customer-portal/customer-portal-outlined-16.svg'),
  'dataflow-02/filled/16': require('./dataflow-02/dataflow-02-filled-16.svg'),
  'dataflow-02/filled/20': require('./dataflow-02/dataflow-02-filled-20.svg'),
  'dataflow-02/outlined/16': require('./dataflow-02/dataflow-02-outlined-16.svg'),
  'dataflow-02/outlined/20': require('./dataflow-02/dataflow-02-outlined-20.svg'),
  'delete/outlined/20': require('./delete/delete-outlined-20.svg'),
  'deliverability/filled/16': require('./deliverability/deliverability-filled-16.svg'),
  'deliverability/filled/20': require('./deliverability/deliverability-filled-20.svg'),
  'deliverability/outlined/16': require('./deliverability/deliverability-outlined-16.svg'),
  'diamond-01/filled/12': require('./diamond-01/diamond-01-filled-12.svg'),
  'diamond-01/filled/16': require('./diamond-01/diamond-01-filled-16.svg'),
  'diamond-01/outlined/16': require('./diamond-01/diamond-01-outlined-16.svg'),
  'discussions/filled/16': require('./discussions/discussions-filled-16.svg'),
  'discussions/outlined/12': require('./discussions/discussions-outlined-12.svg'),
  'discussions/outlined/16': require('./discussions/discussions-outlined-16.svg'),
  'discussions/outlined/20': require('./discussions/discussions-outlined-20.svg'),
  'distribute-spacing-vertical/filled/20': require('./distribute-spacing-vertical/distribute-spacing-vertical-filled-20.svg'),
  'distribute-spacing-vertical/outlined/20': require('./distribute-spacing-vertical/distribute-spacing-vertical-outlined-20.svg'),
  'divider/outlined/16': require('./divider/divider-outlined-16.svg'),
  'divider/outlined/20': require('./divider/divider-outlined-20.svg'),
  'donut-chart/outlined/16': require('./donut-chart/donut-chart-outlined-16.svg'),
  'door-open/outlined/16': require('./door-open/door-open-outlined-16.svg'),
  'dotpoints-01/outlined/12': require('./dotpoints-01/dotpoints-01-outlined-12.svg'),
  'dotpoints-01/outlined/16': require('./dotpoints-01/dotpoints-01-outlined-16.svg'),
  'dotpoints-01/outlined/20': require('./dotpoints-01/dotpoints-01-outlined-20.svg'),
  'dots-grid/filled/20': require('./dots-grid/dots-grid-filled-20.svg'),
  'dots-grid/outlined/20': require('./dots-grid/dots-grid-outlined-20.svg'),
  'dots-horizontal/outlined/16': require('./dots-horizontal/dots-horizontal-outlined-16.svg'),
  'dots-horizontal/outlined/20': require('./dots-horizontal/dots-horizontal-outlined-20.svg'),
  'dots-vertical/outlined/16': require('./dots-vertical/dots-vertical-outlined-16.svg'),
  'dots-vertical/outlined/20': require('./dots-vertical/dots-vertical-outlined-20.svg'),
  'download-02/filled/16': require('./download-02/download-02-filled-16.svg'),
  'download-02/filled/20': require('./download-02/download-02-filled-20.svg'),
  'download-02/outlined/12': require('./download-02/download-02-outlined-12.svg'),
  'download-02/outlined/16': require('./download-02/download-02-outlined-16.svg'),
  'download-02/outlined/20': require('./download-02/download-02-outlined-20.svg'),
  'edit-01/filled/20': require('./edit-01/edit-01-filled-20.svg'),
  'edit-01/outlined/12': require('./edit-01/edit-01-outlined-12.svg'),
  'edit-01/outlined/16': require('./edit-01/edit-01-outlined-16.svg'),
  'edit-01/outlined/20': require('./edit-01/edit-01-outlined-20.svg'),
  'edit-05/filled/16': require('./edit-05/edit-05-filled-16.svg'),
  'edit-05/outlined/16': require('./edit-05/edit-05-outlined-16.svg'),
  'edit-05/outlined/20': require('./edit-05/edit-05-outlined-20.svg'),
  'emoji-activity/outlined/16': require('./emoji-activity/emoji-activity-outlined-16.svg'),
  'emoji-food/outlined/20': require('./emoji-food/emoji-food-outlined-20.svg'),
  'emoji-nature/outlined/20': require('./emoji-nature/emoji-nature-outlined-20.svg'),
  'emoji-symbols/outlined/20': require('./emoji-symbols/emoji-symbols-outlined-20.svg'),
  'expand-01/outlined/16': require('./expand-01/expand-01-outlined-16.svg'),
  'expand-01/outlined/20': require('./expand-01/expand-01-outlined-20.svg'),
  'export/outlined/16': require('./export/export-outlined-16.svg'),
  'export/outlined/20': require('./export/export-outlined-20.svg'),
  'eye-off/filled/16': require('./eye-off/eye-off-filled-16.svg'),
  'eye-off/outlined/16': require('./eye-off/eye-off-outlined-16.svg'),
  'eye/filled/16': require('./eye/eye-filled-16.svg'),
  'eye/filled/20': require('./eye/eye-filled-20.svg'),
  'eye/outlined/16': require('./eye/eye-outlined-16.svg'),
  'face-smile/outlined/16': require('./face-smile/face-smile-outlined-16.svg'),
  'face-smile/outlined/20': require('./face-smile/face-smile-outlined-20.svg'),
  'facebook/outlined/16': require('./facebook/facebook-outlined-16.svg'),
  'feather/filled/16': require('./feather/feather-filled-16.svg'),
  'feather/filled/20': require('./feather/feather-filled-20.svg'),
  'feather/outlined/16': require('./feather/feather-outlined-16.svg'),
  'field-custom/filled/16': require('./field-custom/field-custom-filled-16.svg'),
  'field-custom/filled/20': require('./field-custom/field-custom-filled-20.svg'),
  'field-custom/outlined/12': require('./field-custom/field-custom-outlined-12.svg'),
  'field-custom/outlined/16': require('./field-custom/field-custom-outlined-16.svg'),
  'file-02/filled/16': require('./file-02/file-02-filled-16.svg'),
  'file-02/filled/20': require('./file-02/file-02-filled-20.svg'),
  'file-02/outlined/12': require('./file-02/file-02-outlined-12.svg'),
  'file-02/outlined/16': require('./file-02/file-02-outlined-16.svg'),
  'file-02/outlined/20': require('./file-02/file-02-outlined-20.svg'),
  'file-05/filled/12': require('./file-05/file-05-filled-12.svg'),
  'file-05/filled/16': require('./file-05/file-05-filled-16.svg'),
  'file-05/outlined/16': require('./file-05/file-05-outlined-16.svg'),
  'file-05/outlined/20': require('./file-05/file-05-outlined-20.svg'),
  'file-check-02/outlined/16': require('./file-check-02/file-check-02-outlined-16.svg'),
  'file-download-03/outlined/16': require('./file-download-03/file-download-03-outlined-16.svg'),
  'file-search-01/filled/16': require('./file-search-01/file-search-01-filled-16.svg'),
  'filter-lines/filled/16': require('./filter-lines/filter-lines-filled-16.svg'),
  'filter-lines/outlined/12': require('./filter-lines/filter-lines-outlined-12.svg'),
  'filter-lines/outlined/16': require('./filter-lines/filter-lines-outlined-16.svg'),
  'filter-lines/outlined/20': require('./filter-lines/filter-lines-outlined-20.svg'),
  'first-page/filled/16': require('./first-page/first-page-filled-16.svg'),
  'fix-grammar/outlined/12': require('./fix-grammar/fix-grammar-outlined-12.svg'),
  'fix-grammar/outlined/16': require('./fix-grammar/fix-grammar-outlined-16.svg'),
  'flag-01/outlined/16': require('./flag-01/flag-01-outlined-16.svg'),
  'flag-01/outlined/20': require('./flag-01/flag-01-outlined-20.svg'),
  'flip-backward/outlined/12': require('./flip-backward/flip-backward-outlined-12.svg'),
  'flip-backward/outlined/16': require('./flip-backward/flip-backward-outlined-16.svg'),
  'flip-forward-plus/outlined/16': require('./flip-forward-plus/flip-forward-plus-outlined-16.svg'),
  'focus/outlined/20': require('./focus/focus-outlined-20.svg'),
  'folder/filled/16': require('./folder/folder-filled-16.svg'),
  'folder/filled/20': require('./folder/folder-filled-20.svg'),
  'folder/outlined/16': require('./folder/folder-outlined-16.svg'),
  'folder/outlined/20': require('./folder/folder-outlined-20.svg'),
  'formatting-color/outlined/16': require('./formatting-color/formatting-color-outlined-16.svg'),
  'formatting-color/outlined/20': require('./formatting-color/formatting-color-outlined-20.svg'),
  'formatting-highlight/outlined/16': require('./formatting-highlight/formatting-highlight-outlined-16.svg'),
  'formatting-highlight/outlined/20': require('./formatting-highlight/formatting-highlight-outlined-20.svg'),
  'formatting-list/outlined/16': require('./formatting-list/formatting-list-outlined-16.svg'),
  'formatting-quote/outlined/16': require('./formatting-quote/formatting-quote-outlined-16.svg'),
  'formatting-quote/outlined/20': require('./formatting-quote/formatting-quote-outlined-20.svg'),
  'formatting/outlined/16': require('./formatting/formatting-outlined-16.svg'),
  'formatting/outlined/20': require('./formatting/formatting-outlined-20.svg'),
  'forward-10s/filled/20': require('./forward-10s/forward-10s-filled-20.svg'),
  'front-logo/filled/12': require('./front-logo/front-logo-filled-12.svg'),
  'geometry/outlined/16': require('./geometry/geometry-outlined-16.svg'),
  'gif/outlined/16': require('./gif/gif-outlined-16.svg'),
  'gif/outlined/20': require('./gif/gif-outlined-20.svg'),
  'gift-01/outlined/16': require('./gift-01/gift-01-outlined-16.svg'),
  'git-branch-01/filled/12': require('./git-branch-01/git-branch-01-filled-12.svg'),
  'git-branch-01/filled/16': require('./git-branch-01/git-branch-01-filled-16.svg'),
  'git-branch-01/filled/20': require('./git-branch-01/git-branch-01-filled-20.svg'),
  'git-branch-01/outlined/12': require('./git-branch-01/git-branch-01-outlined-12.svg'),
  'git-branch-01/outlined/16': require('./git-branch-01/git-branch-01-outlined-16.svg'),
  'globe-01/filled/16': require('./globe-01/globe-01-filled-16.svg'),
  'globe-01/outlined/12': require('./globe-01/globe-01-outlined-12.svg'),
  'globe-01/outlined/16': require('./globe-01/globe-01-outlined-16.svg'),
  'globe-04/filled/20': require('./globe-04/globe-04-filled-20.svg'),
  'go-to-conversation/outlined/20': require('./go-to-conversation/go-to-conversation-outlined-20.svg'),
  'google-play/filled/16': require('./google-play/google-play-filled-16.svg'),
  'google-play/outlined/16': require('./google-play/google-play-outlined-16.svg'),
  'grab-handle/outlined/16': require('./grab-handle/grab-handle-outlined-16.svg'),
  'graduation-hat-01/filled/16': require('./graduation-hat-01/graduation-hat-01-filled-16.svg'),
  'graduation-hat-01/outlined/20': require('./graduation-hat-01/graduation-hat-01-outlined-20.svg'),
  'grammar/outlined/16': require('./grammar/grammar-outlined-16.svg'),
  'grid-01/filled/16': require('./grid-01/grid-01-filled-16.svg'),
  'grid-01/filled/20': require('./grid-01/grid-01-filled-20.svg'),
  'grid-01/outlined/16': require('./grid-01/grid-01-outlined-16.svg'),
  'grid-01/outlined/20': require('./grid-01/grid-01-outlined-20.svg'),
  'heart/filled/20': require('./heart/heart-filled-20.svg'),
  'heart/outlined/16': require('./heart/heart-outlined-16.svg'),
  'heart/outlined/20': require('./heart/heart-outlined-20.svg'),
  'help-center/filled/16': require('./help-center/help-center-filled-16.svg'),
  'help-center/outlined/16': require('./help-center/help-center-outlined-16.svg'),
  'help-circle/filled/12': require('./help-circle/help-circle-filled-12.svg'),
  'help-circle/filled/16': require('./help-circle/help-circle-filled-16.svg'),
  'help-circle/filled/20': require('./help-circle/help-circle-filled-20.svg'),
  'help-circle/outlined/12': require('./help-circle/help-circle-outlined-12.svg'),
  'help-circle/outlined/16': require('./help-circle/help-circle-outlined-16.svg'),
  'help-circle/outlined/20': require('./help-circle/help-circle-outlined-20.svg'),
  'home-05/filled/16': require('./home-05/home-05-filled-16.svg'),
  'home-05/filled/20': require('./home-05/home-05-filled-20.svg'),
  'home-05/outlined/16': require('./home-05/home-05-outlined-16.svg'),
  'hourglass-check/filled/16': require('./hourglass-check/hourglass-check-filled-16.svg'),
  'hourglass-check/filled/20': require('./hourglass-check/hourglass-check-filled-20.svg'),
  'hourglass-check/outlined/16': require('./hourglass-check/hourglass-check-outlined-16.svg'),
  'hourglass-check/outlined/20': require('./hourglass-check/hourglass-check-outlined-20.svg'),
  'image-03/filled/16': require('./image-03/image-03-filled-16.svg'),
  'image-03/outlined/20': require('./image-03/image-03-outlined-20.svg'),
  'inbox-01/filled/16': require('./inbox-01/inbox-01-filled-16.svg'),
  'inbox-01/filled/20': require('./inbox-01/inbox-01-filled-20.svg'),
  'inbox-01/outlined/12': require('./inbox-01/inbox-01-outlined-12.svg'),
  'inbox-01/outlined/16': require('./inbox-01/inbox-01-outlined-16.svg'),
  'inbox-01/outlined/20': require('./inbox-01/inbox-01-outlined-20.svg'),
  'inbox-list/filled/16': require('./inbox-list/inbox-list-filled-16.svg'),
  'inbox-list/outlined/16': require('./inbox-list/inbox-list-outlined-16.svg'),
  'info-circle/filled/16': require('./info-circle/info-circle-filled-16.svg'),
  'info-circle/filled/20': require('./info-circle/info-circle-filled-20.svg'),
  'info-circle/outlined/16': require('./info-circle/info-circle-outlined-16.svg'),
  'info-circle/outlined/20': require('./info-circle/info-circle-outlined-20.svg'),
  'info-history/outlined/20': require('./info-history/info-history-outlined-20.svg'),
  'intercom/outlined/16': require('./intercom/intercom-outlined-16.svg'),
  'italic-01/outlined/16': require('./italic-01/italic-01-outlined-16.svg'),
  'italic-01/outlined/20': require('./italic-01/italic-01-outlined-20.svg'),
  'key-metric/outlined/16': require('./key-metric/key-metric-outlined-16.svg'),
  'keyboard-02/filled/20': require('./keyboard-02/keyboard-02-filled-20.svg'),
  'last-page/outlined/16': require('./last-page/last-page-outlined-16.svg'),
  'layers-three-01/filled/16': require('./layers-three-01/layers-three-01-filled-16.svg'),
  'layers-three-01/filled/20': require('./layers-three-01/layers-three-01-filled-20.svg'),
  'layers-three-01/outlined/12': require('./layers-three-01/layers-three-01-outlined-12.svg'),
  'layers-three-01/outlined/16': require('./layers-three-01/layers-three-01-outlined-16.svg'),
  'layout-alt-01/filled/16': require('./layout-alt-01/layout-alt-01-filled-16.svg'),
  'layout-alt-01/outlined/16': require('./layout-alt-01/layout-alt-01-outlined-16.svg'),
  'layout-grid-02/outlined/16': require('./layout-grid-02/layout-grid-02-outlined-16.svg'),
  'layout-left/outlined/16': require('./layout-left/layout-left-outlined-16.svg'),
  'layout-left/outlined/20': require('./layout-left/layout-left-outlined-20.svg'),
  'layout-right/outlined/20': require('./layout-right/layout-right-outlined-20.svg'),
  'lightbulb-04/filled/12': require('./lightbulb-04/lightbulb-04-filled-12.svg'),
  'lightbulb-04/filled/16': require('./lightbulb-04/lightbulb-04-filled-16.svg'),
  'lightbulb-04/filled/20': require('./lightbulb-04/lightbulb-04-filled-20.svg'),
  'lightbulb-04/outlined/20': require('./lightbulb-04/lightbulb-04-outlined-20.svg'),
  'lightning-01/filled/12': require('./lightning-01/lightning-01-filled-12.svg'),
  'lightning-01/filled/16': require('./lightning-01/lightning-01-filled-16.svg'),
  'lightning-01/filled/20': require('./lightning-01/lightning-01-filled-20.svg'),
  'lightning-01/outlined/12': require('./lightning-01/lightning-01-outlined-12.svg'),
  'lightning-01/outlined/16': require('./lightning-01/lightning-01-outlined-16.svg'),
  'lightning-01/outlined/20': require('./lightning-01/lightning-01-outlined-20.svg'),
  'line-chart-up-01/outlined/16': require('./line-chart-up-01/line-chart-up-01-outlined-16.svg'),
  'linear-rule/filled/16': require('./linear-rule/linear-rule-filled-16.svg'),
  'linear-rule/filled/20': require('./linear-rule/linear-rule-filled-20.svg'),
  'linear-rule/outlined/16': require('./linear-rule/linear-rule-outlined-16.svg'),
  'link-03/outlined/12': require('./link-03/link-03-outlined-12.svg'),
  'link-03/outlined/16': require('./link-03/link-03-outlined-16.svg'),
  'link-03/outlined/20': require('./link-03/link-03-outlined-20.svg'),
  'link-broken-03/filled/16': require('./link-broken-03/link-broken-03-filled-16.svg'),
  'link-broken-03/filled/20': require('./link-broken-03/link-broken-03-filled-20.svg'),
  'link-broken-03/outlined/12': require('./link-broken-03/link-broken-03-outlined-12.svg'),
  'link-broken-03/outlined/16': require('./link-broken-03/link-broken-03-outlined-16.svg'),
  'link-broken-03/outlined/20': require('./link-broken-03/link-broken-03-outlined-20.svg'),
  'link-external-02/filled/20': require('./link-external-02/link-external-02-filled-20.svg'),
  'link-external-02/outlined/12': require('./link-external-02/link-external-02-outlined-12.svg'),
  'link-external-02/outlined/16': require('./link-external-02/link-external-02-outlined-16.svg'),
  'link-external-02/outlined/20': require('./link-external-02/link-external-02-outlined-20.svg'),
  'link-to/filled/16': require('./link-to/link-to-filled-16.svg'),
  'link-to/outlined/16': require('./link-to/link-to-outlined-16.svg'),
  'lock-01/filled/12': require('./lock-01/lock-01-filled-12.svg'),
  'lock-01/filled/16': require('./lock-01/lock-01-filled-16.svg'),
  'lock-01/filled/20': require('./lock-01/lock-01-filled-20.svg'),
  'lock-01/outlined/16': require('./lock-01/lock-01-outlined-16.svg'),
  'log-out-02/outlined/16': require('./log-out-02/log-out-02-outlined-16.svg'),
  'longer/outlined/12': require('./longer/longer-outlined-12.svg'),
  'longer/outlined/16': require('./longer/longer-outlined-16.svg'),
  'mail-01/outlined/12': require('./mail-01/mail-01-outlined-12.svg'),
  'mail-01/outlined/16': require('./mail-01/mail-01-outlined-16.svg'),
  'mail-01/outlined/20': require('./mail-01/mail-01-outlined-20.svg'),
  'mail-04/outlined/16': require('./mail-04/mail-04-outlined-16.svg'),
  'mail-notification/outlined/16': require('./mail-notification/mail-notification-outlined-16.svg'),
  'marker-pin-01/outlined/16': require('./marker-pin-01/marker-pin-01-outlined-16.svg'),
  'menu-01/outlined/20': require('./menu-01/menu-01-outlined-20.svg'),
  'merge/filled/12': require('./merge/merge-filled-12.svg'),
  'merge/filled/16': require('./merge/merge-filled-16.svg'),
  'merge/outlined/12': require('./merge/merge-outlined-12.svg'),
  'merge/outlined/16': require('./merge/merge-outlined-16.svg'),
  'merge/outlined/20': require('./merge/merge-outlined-20.svg'),
  'message-square-01/filled/20': require('./message-square-01/message-square-01-filled-20.svg'),
  'message-square-01/outlined/12': require('./message-square-01/message-square-01-outlined-12.svg'),
  'message-square-01/outlined/16': require('./message-square-01/message-square-01-outlined-16.svg'),
  'message-square-01/outlined/20': require('./message-square-01/message-square-01-outlined-20.svg'),
  'message-template/filled/16': require('./message-template/message-template-filled-16.svg'),
  'message-template/filled/20': require('./message-template/message-template-filled-20.svg'),
  'message-template/outlined/16': require('./message-template/message-template-outlined-16.svg'),
  'message-template/outlined/20': require('./message-template/message-template-outlined-20.svg'),
  'microphone-01/outlined/16': require('./microphone-01/microphone-01-outlined-16.svg'),
  'minimize-01/outlined/16': require('./minimize-01/minimize-01-outlined-16.svg'),
  'minimize-01/outlined/20': require('./minimize-01/minimize-01-outlined-20.svg'),
  'minus-circle/filled/12': require('./minus-circle/minus-circle-filled-12.svg'),
  'minus-circle/filled/16': require('./minus-circle/minus-circle-filled-16.svg'),
  'minus-circle/outlined/12': require('./minus-circle/minus-circle-outlined-12.svg'),
  'minus-circle/outlined/16': require('./minus-circle/minus-circle-outlined-16.svg'),
  'minus/outlined/16': require('./minus/minus-outlined-16.svg'),
  'minus/outlined/20': require('./minus/minus-outlined-20.svg'),
  'moon-02/filled/16': require('./moon-02/moon-02-filled-16.svg'),
  'muted-status/filled/12': require('./muted-status/muted-status-filled-12.svg'),
  'numbers/outlined/12': require('./numbers/numbers-outlined-12.svg'),
  'numbers/outlined/16': require('./numbers/numbers-outlined-16.svg'),
  'numbers/outlined/20': require('./numbers/numbers-outlined-20.svg'),
  'open/filled/16': require('./open/open-filled-16.svg'),
  'outbox/filled/16': require('./outbox/outbox-filled-16.svg'),
  'outbox/filled/20': require('./outbox/outbox-filled-20.svg'),
  'outbox/outlined/16': require('./outbox/outbox-outlined-16.svg'),
  'paperclip/outlined/12': require('./paperclip/paperclip-outlined-12.svg'),
  'paperclip/outlined/16': require('./paperclip/paperclip-outlined-16.svg'),
  'paperclip/outlined/20': require('./paperclip/paperclip-outlined-20.svg'),
  'paragraph-spacing/outlined/16': require('./paragraph-spacing/paragraph-spacing-outlined-16.svg'),
  'pause-circle/filled/20': require('./pause-circle/pause-circle-filled-20.svg'),
  'pause-circle/outlined/20': require('./pause-circle/pause-circle-outlined-20.svg'),
  'pause/filled/20': require('./pause/pause-filled-20.svg'),
  'person-speaking/outlined/16': require('./person-speaking/person-speaking-outlined-16.svg'),
  'phone-call-01/filled/16': require('./phone-call-01/phone-call-01-filled-16.svg'),
  'phone-call-01/filled/20': require('./phone-call-01/phone-call-01-filled-20.svg'),
  'phone-call-01/outlined/12': require('./phone-call-01/phone-call-01-outlined-12.svg'),
  'phone-call-01/outlined/16': require('./phone-call-01/phone-call-01-outlined-16.svg'),
  'phone-call-01/outlined/20': require('./phone-call-01/phone-call-01-outlined-20.svg'),
  'phone-hang-up/outlined/12': require('./phone-hang-up/phone-hang-up-outlined-12.svg'),
  'phone-hang-up/outlined/20': require('./phone-hang-up/phone-hang-up-outlined-20.svg'),
  'phone-incoming-01/filled/16': require('./phone-incoming-01/phone-incoming-01-filled-16.svg'),
  'phone-incoming-01/outlined/12': require('./phone-incoming-01/phone-incoming-01-outlined-12.svg'),
  'phone-outgoing-01/filled/16': require('./phone-outgoing-01/phone-outgoing-01-filled-16.svg'),
  'phone-outgoing-02/outlined/12': require('./phone-outgoing-02/phone-outgoing-02-outlined-12.svg'),
  'phone-pause/outlined/12': require('./phone-pause/phone-pause-outlined-12.svg'),
  'phone-x/filled/16': require('./phone-x/phone-x-filled-16.svg'),
  'phone-x/outlined/12': require('./phone-x/phone-x-outlined-12.svg'),
  'phone/filled/20': require('./phone/phone-filled-20.svg'),
  'phone/outlined/12': require('./phone/phone-outlined-12.svg'),
  'phone/outlined/16': require('./phone/phone-outlined-16.svg'),
  'phone/outlined/20': require('./phone/phone-outlined-20.svg'),
  'pie-chart-01/outlined/16': require('./pie-chart-01/pie-chart-01-outlined-16.svg'),
  'pin-02/filled/12': require('./pin-02/pin-02-filled-12.svg'),
  'pin-02/filled/16': require('./pin-02/pin-02-filled-16.svg'),
  'pin-02/outlined/16': require('./pin-02/pin-02-outlined-16.svg'),
  'pin-to-bottom/outlined/16': require('./pin-to-bottom/pin-to-bottom-outlined-16.svg'),
  'pin-to-right/outlined/16': require('./pin-to-right/pin-to-right-outlined-16.svg'),
  'plane/outlined/20': require('./plane/plane-outlined-20.svg'),
  'play/filled/20': require('./play/play-filled-20.svg'),
  'play/outlined/12': require('./play/play-outlined-12.svg'),
  'playbook-temporary/filled/16': require('./playbook-temporary/playbook-temporary-filled-16.svg'),
  'playbook-temporary/filled/20': require('./playbook-temporary/playbook-temporary-filled-20.svg'),
  'playbook-temporary/outlined/16': require('./playbook-temporary/playbook-temporary-outlined-16.svg'),
  'plus-circle/filled/16': require('./plus-circle/plus-circle-filled-16.svg'),
  'plus-circle/outlined/16': require('./plus-circle/plus-circle-outlined-16.svg'),
  'plus-circle/outlined/20': require('./plus-circle/plus-circle-outlined-20.svg'),
  'plus/outlined/12': require('./plus/plus-outlined-12.svg'),
  'plus/outlined/16': require('./plus/plus-outlined-16.svg'),
  'plus/outlined/20': require('./plus/plus-outlined-20.svg'),
  'popin/outlined/20': require('./popin/popin-outlined-20.svg'),
  'printer/outlined/16': require('./printer/printer-outlined-16.svg'),
  'q-a-smart/filled/16': require('./q-a-smart/q-a-smart-filled-16.svg'),
  'q-a-smart/filled/20': require('./q-a-smart/q-a-smart-filled-20.svg'),
  'q-a-smart/outlined/16': require('./q-a-smart/q-a-smart-outlined-16.svg'),
  'refresh-cw-01/filled/16': require('./refresh-cw-01/refresh-cw-01-filled-16.svg'),
  'refresh-cw-01/filled/20': require('./refresh-cw-01/refresh-cw-01-filled-20.svg'),
  'refresh-cw-01/outlined/12': require('./refresh-cw-01/refresh-cw-01-outlined-12.svg'),
  'refresh-cw-01/outlined/16': require('./refresh-cw-01/refresh-cw-01-outlined-16.svg'),
  'refresh-cw-01/outlined/20': require('./refresh-cw-01/refresh-cw-01-outlined-20.svg'),
  'refresh-cw-02/outlined/16': require('./refresh-cw-02/refresh-cw-02-outlined-16.svg'),
  'refresh-cw-02/outlined/20': require('./refresh-cw-02/refresh-cw-02-outlined-20.svg'),
  'repeat-01/outlined/16': require('./repeat-01/repeat-01-outlined-16.svg'),
  'repeat-01/outlined/20': require('./repeat-01/repeat-01-outlined-20.svg'),
  'repeat-02/outlined/16': require('./repeat-02/repeat-02-outlined-16.svg'),
  'replace-all/outlined/16': require('./replace-all/replace-all-outlined-16.svg'),
  'rewind-10s/filled/20': require('./rewind-10s/rewind-10s-filled-20.svg'),
  'rocket-02/filled/16': require('./rocket-02/rocket-02-filled-16.svg'),
  'rocket-02/filled/20': require('./rocket-02/rocket-02-filled-20.svg'),
  'rule-tester/outlined/16': require('./rule-tester/rule-tester-outlined-16.svg'),
  'rule-tester/outlined/20': require('./rule-tester/rule-tester-outlined-20.svg'),
  'save/outlined/20': require('./save/save-outlined-20.svg'),
  'schedule/filled/16': require('./schedule/schedule-filled-16.svg'),
  'schedule/outlined/16': require('./schedule/schedule-outlined-16.svg'),
  'schedule/outlined/20': require('./schedule/schedule-outlined-20.svg'),
  'search-sm/outlined/12': require('./search-sm/search-sm-outlined-12.svg'),
  'search-sm/outlined/16': require('./search-sm/search-sm-outlined-16.svg'),
  'search-sm/outlined/20': require('./search-sm/search-sm-outlined-20.svg'),
  'send-04/outlined/16': require('./send-04/send-04-outlined-16.svg'),
  'send/filled/16': require('./send/send-filled-16.svg'),
  'send/filled/20': require('./send/send-filled-20.svg'),
  'send/outlined/16': require('./send/send-outlined-16.svg'),
  'send/outlined/20': require('./send/send-outlined-20.svg'),
  'settings-02/filled/12': require('./settings-02/settings-02-filled-12.svg'),
  'settings-02/filled/16': require('./settings-02/settings-02-filled-16.svg'),
  'settings-02/filled/20': require('./settings-02/settings-02-filled-20.svg'),
  'settings-02/outlined/12': require('./settings-02/settings-02-outlined-12.svg'),
  'settings-02/outlined/16': require('./settings-02/settings-02-outlined-16.svg'),
  'settings-02/outlined/20': require('./settings-02/settings-02-outlined-20.svg'),
  'settings-03/filled/16': require('./settings-03/settings-03-filled-16.svg'),
  'settings-03/filled/20': require('./settings-03/settings-03-filled-20.svg'),
  'settings-03/outlined/12': require('./settings-03/settings-03-outlined-12.svg'),
  'settings-03/outlined/16': require('./settings-03/settings-03-outlined-16.svg'),
  'settings-03/outlined/20': require('./settings-03/settings-03-outlined-20.svg'),
  'shift/filled/16': require('./shift/shift-filled-16.svg'),
  'shift/outlined/16': require('./shift/shift-outlined-16.svg'),
  'shorter/outlined/12': require('./shorter/shorter-outlined-12.svg'),
  'shorter/outlined/16': require('./shorter/shorter-outlined-16.svg'),
  'sidebar/filled/16': require('./sidebar/sidebar-filled-16.svg'),
  'sidebar/outlined/16': require('./sidebar/sidebar-outlined-16.svg'),
  'sidebar/outlined/20': require('./sidebar/sidebar-outlined-20.svg'),
  'slack/filled/16': require('./slack/slack-filled-16.svg'),
  'slash-circle-01/outlined/16': require('./slash-circle-01/slash-circle-01-outlined-16.svg'),
  'slash-circle-01/outlined/20': require('./slash-circle-01/slash-circle-01-outlined-20.svg'),
  'sliders-04/filled/16': require('./sliders-04/sliders-04-filled-16.svg'),
  'sliders-04/outlined/16': require('./sliders-04/sliders-04-outlined-16.svg'),
  'split/filled/12': require('./split/split-filled-12.svg'),
  'split/filled/16': require('./split/split-filled-16.svg'),
  'split/outlined/12': require('./split/split-outlined-12.svg'),
  'split/outlined/16': require('./split/split-outlined-16.svg'),
  'square/filled/12': require('./square/square-filled-12.svg'),
  'square/filled/16': require('./square/square-filled-16.svg'),
  'square/filled/20': require('./square/square-filled-20.svg'),
  'star-01/filled/12': require('./star-01/star-01-filled-12.svg'),
  'star-01/filled/16': require('./star-01/star-01-filled-16.svg'),
  'star-01/filled/20': require('./star-01/star-01-filled-20.svg'),
  'star-01/outlined/16': require('./star-01/star-01-outlined-16.svg'),
  'star-01/outlined/20': require('./star-01/star-01-outlined-20.svg'),
  'star-04/filled/12': require('./star-04/star-04-filled-12.svg'),
  'star-04/filled/16': require('./star-04/star-04-filled-16.svg'),
  'star-04/filled/20': require('./star-04/star-04-filled-20.svg'),
  'star-04/outlined/16': require('./star-04/star-04-outlined-16.svg'),
  'star-04/outlined/20': require('./star-04/star-04-outlined-20.svg'),
  'status-change/filled/16': require('./status-change/status-change-filled-16.svg'),
  'status-change/filled/20': require('./status-change/status-change-filled-20.svg'),
  'status-change/outlined/16': require('./status-change/status-change-outlined-16.svg'),
  'status-change/outlined/20': require('./status-change/status-change-outlined-20.svg'),
  'sticker-square/outlined/16': require('./sticker-square/sticker-square-outlined-16.svg'),
  'strikethrough-01/outlined/16': require('./strikethrough-01/strikethrough-01-outlined-16.svg'),
  'strikethrough-01/outlined/20': require('./strikethrough-01/strikethrough-01-outlined-20.svg'),
  'switch-horizontal-01/filled/16': require('./switch-horizontal-01/switch-horizontal-01-filled-16.svg'),
  'switch-horizontal-01/outlined/12': require('./switch-horizontal-01/switch-horizontal-01-outlined-12.svg'),
  'switch-vertical-01/outlined/16': require('./switch-vertical-01/switch-vertical-01-outlined-16.svg'),
  'table-column/outlined/16': require('./table-column/table-column-outlined-16.svg'),
  'table-column/outlined/20': require('./table-column/table-column-outlined-20.svg'),
  'table/filled/16': require('./table/table-filled-16.svg'),
  'table/filled/20': require('./table/table-filled-20.svg'),
  'table/outlined/16': require('./table/table-outlined-16.svg'),
  'table/outlined/20': require('./table/table-outlined-20.svg'),
  'tag-01/filled/12': require('./tag-01/tag-01-filled-12.svg'),
  'tag-01/filled/16': require('./tag-01/tag-01-filled-16.svg'),
  'tag-01/filled/20': require('./tag-01/tag-01-filled-20.svg'),
  'tag-01/outlined/12': require('./tag-01/tag-01-outlined-12.svg'),
  'tag-01/outlined/16': require('./tag-01/tag-01-outlined-16.svg'),
  'tag-01/outlined/20': require('./tag-01/tag-01-outlined-20.svg'),
  'tag-03/filled/16': require('./tag-03/tag-03-filled-16.svg'),
  'tag-03/outlined/16': require('./tag-03/tag-03-outlined-16.svg'),
  'tag-03/outlined/20': require('./tag-03/tag-03-outlined-20.svg'),
  'tag-04/filled/12': require('./tag-04/tag-04-filled-12.svg'),
  'tag-04/filled/16': require('./tag-04/tag-04-filled-16.svg'),
  'tag-04/filled/20': require('./tag-04/tag-04-filled-20.svg'),
  'tag-04/outlined/12': require('./tag-04/tag-04-outlined-12.svg'),
  'tag-04/outlined/16': require('./tag-04/tag-04-outlined-16.svg'),
  'target-03/filled/16': require('./target-03/target-03-filled-16.svg'),
  'target-03/outlined/12': require('./target-03/target-03-outlined-12.svg'),
  'target-03/outlined/16': require('./target-03/target-03-outlined-16.svg'),
  'target-stroke-03/outlined/16': require('./target-stroke-03/target-stroke-03-outlined-16.svg'),
  'task/filled/12': require('./task/task-filled-12.svg'),
  'task/filled/16': require('./task/task-filled-16.svg'),
  'task/filled/20': require('./task/task-filled-20.svg'),
  'task/outlined/12': require('./task/task-outlined-12.svg'),
  'task/outlined/16': require('./task/task-outlined-16.svg'),
  'task/outlined/20': require('./task/task-outlined-20.svg'),
  'thumbs-down/filled/16': require('./thumbs-down/thumbs-down-filled-16.svg'),
  'thumbs-down/filled/20': require('./thumbs-down/thumbs-down-filled-20.svg'),
  'thumbs-down/outlined/16': require('./thumbs-down/thumbs-down-outlined-16.svg'),
  'thumbs-down/outlined/20': require('./thumbs-down/thumbs-down-outlined-20.svg'),
  'thumbs-up/filled/16': require('./thumbs-up/thumbs-up-filled-16.svg'),
  'thumbs-up/filled/20': require('./thumbs-up/thumbs-up-filled-20.svg'),
  'thumbs-up/outlined/16': require('./thumbs-up/thumbs-up-outlined-16.svg'),
  'thumbs-up/outlined/20': require('./thumbs-up/thumbs-up-outlined-20.svg'),
  'ticket-01/filled/16': require('./ticket-01/ticket-01-filled-16.svg'),
  'ticket-01/outlined/16': require('./ticket-01/ticket-01-outlined-16.svg'),
  'tool/outlined/16': require('./tool/tool-outlined-16.svg'),
  'translate-01/outlined/12': require('./translate-01/translate-01-outlined-12.svg'),
  'translate-01/outlined/16': require('./translate-01/translate-01-outlined-16.svg'),
  'trash-03/filled/16': require('./trash-03/trash-03-filled-16.svg'),
  'trash-03/filled/20': require('./trash-03/trash-03-filled-20.svg'),
  'trash-03/outlined/12': require('./trash-03/trash-03-outlined-12.svg'),
  'trash-03/outlined/16': require('./trash-03/trash-03-outlined-16.svg'),
  'trash-03/outlined/20': require('./trash-03/trash-03-outlined-20.svg'),
  'twitter-x/filled/20': require('./twitter-x/twitter-x-filled-20.svg'),
  'twitter-x/outlined/16': require('./twitter-x/twitter-x-outlined-16.svg'),
  'type-strikethrough-01/outlined/16': require('./type-strikethrough-01/type-strikethrough-01-outlined-16.svg'),
  'type-strikethrough-01/outlined/20': require('./type-strikethrough-01/type-strikethrough-01-outlined-20.svg'),
  'unassigned/filled/16': require('./unassigned/unassigned-filled-16.svg'),
  'unassigned/outlined/16': require('./unassigned/unassigned-outlined-16.svg'),
  'underline-01/outlined/16': require('./underline-01/underline-01-outlined-16.svg'),
  'underline-01/outlined/20': require('./underline-01/underline-01-outlined-20.svg'),
  'unpin/outlined/16': require('./unpin/unpin-outlined-16.svg'),
  'user-01/filled/16': require('./user-01/user-01-filled-16.svg'),
  'user-01/filled/20': require('./user-01/user-01-filled-20.svg'),
  'user-01/outlined/12': require('./user-01/user-01-outlined-12.svg'),
  'user-01/outlined/16': require('./user-01/user-01-outlined-16.svg'),
  'user-01/outlined/20': require('./user-01/user-01-outlined-20.svg'),
  'user-check-01/filled/16': require('./user-check-01/user-check-01-filled-16.svg'),
  'user-check-01/outlined/16': require('./user-check-01/user-check-01-outlined-16.svg'),
  'user-check-01/outlined/20': require('./user-check-01/user-check-01-outlined-20.svg'),
  'user-circle/filled/16': require('./user-circle/user-circle-filled-16.svg'),
  'user-circle/filled/20': require('./user-circle/user-circle-filled-20.svg'),
  'user-circle/outlined/16': require('./user-circle/user-circle-outlined-16.svg'),
  'user-circle/outlined/20': require('./user-circle/user-circle-outlined-20.svg'),
  'user-edit/filled/16': require('./user-edit/user-edit-filled-16.svg'),
  'user-edit/filled/20': require('./user-edit/user-edit-filled-20.svg'),
  'user-left-01/filled/12': require('./user-left-01/user-left-01-filled-12.svg'),
  'user-left-01/filled/16': require('./user-left-01/user-left-01-filled-16.svg'),
  'user-left-01/filled/20': require('./user-left-01/user-left-01-filled-20.svg'),
  'user-left-01/outlined/12': require('./user-left-01/user-left-01-outlined-12.svg'),
  'user-left-01/outlined/16': require('./user-left-01/user-left-01-outlined-16.svg'),
  'user-left-01/outlined/20': require('./user-left-01/user-left-01-outlined-20.svg'),
  'user-plus-01/outlined/12': require('./user-plus-01/user-plus-01-outlined-12.svg'),
  'user-plus-01/outlined/16': require('./user-plus-01/user-plus-01-outlined-16.svg'),
  'user-plus-01/outlined/20': require('./user-plus-01/user-plus-01-outlined-20.svg'),
  'user-right-01/filled/12': require('./user-right-01/user-right-01-filled-12.svg'),
  'user-right-01/filled/16': require('./user-right-01/user-right-01-filled-16.svg'),
  'user-right-01/filled/20': require('./user-right-01/user-right-01-filled-20.svg'),
  'user-right-01/outlined/12': require('./user-right-01/user-right-01-outlined-12.svg'),
  'user-right-01/outlined/16': require('./user-right-01/user-right-01-outlined-16.svg'),
  'user-right-off/filled/12': require('./user-right-off/user-right-off-filled-12.svg'),
  'user-right-off/filled/20': require('./user-right-off/user-right-off-filled-20.svg'),
  'user-right-off/outlined/16': require('./user-right-off/user-right-off-outlined-16.svg'),
  'user-square/filled/16': require('./user-square/user-square-filled-16.svg'),
  'user-square/filled/20': require('./user-square/user-square-filled-20.svg'),
  'user-square/outlined/16': require('./user-square/user-square-outlined-16.svg'),
  'user-square/outlined/20': require('./user-square/user-square-outlined-20.svg'),
  'user-x-01/filled/16': require('./user-x-01/user-x-01-filled-16.svg'),
  'user-x-01/filled/20': require('./user-x-01/user-x-01-filled-20.svg'),
  'user-x-01/outlined/12': require('./user-x-01/user-x-01-outlined-12.svg'),
  'user-x-01/outlined/16': require('./user-x-01/user-x-01-outlined-16.svg'),
  'users-01/filled/12': require('./users-01/users-01-filled-12.svg'),
  'users-01/filled/16': require('./users-01/users-01-filled-16.svg'),
  'users-01/filled/20': require('./users-01/users-01-filled-20.svg'),
  'users-01/outlined/12': require('./users-01/users-01-outlined-12.svg'),
  'users-01/outlined/16': require('./users-01/users-01-outlined-16.svg'),
  'users-01/outlined/20': require('./users-01/users-01-outlined-20.svg'),
  'users-left/outlined/20': require('./users-left/users-left-outlined-20.svg'),
  'users-plus/outlined/16': require('./users-plus/users-plus-outlined-16.svg'),
  'users/filled/16': require('./users/users-filled-16.svg'),
  'users/filled/20': require('./users/users-filled-20.svg'),
  'users/outlined/16': require('./users/users-outlined-16.svg'),
  'variable/outlined/16': require('./variable/variable-outlined-16.svg'),
  'variable/outlined/20': require('./variable/variable-outlined-20.svg'),
  'video-recorder/outlined/16': require('./video-recorder/video-recorder-outlined-16.svg'),
  'video-recorder/outlined/20': require('./video-recorder/video-recorder-outlined-20.svg'),
  'views/filled/12': require('./views/views-filled-12.svg'),
  'views/filled/16': require('./views/views-filled-16.svg'),
  'views/filled/20': require('./views/views-filled-20.svg'),
  'views/outlined/12': require('./views/views-outlined-12.svg'),
  'views/outlined/16': require('./views/views-outlined-16.svg'),
  'views/outlined/20': require('./views/views-outlined-20.svg'),
  'visitor-source/outlined/16': require('./visitor-source/visitor-source-outlined-16.svg'),
  'visitor-source/outlined/20': require('./visitor-source/visitor-source-outlined-20.svg'),
  'voicemail/filled/16': require('./voicemail/voicemail-filled-16.svg'),
  'volume-max/filled/20': require('./volume-max/volume-max-filled-20.svg'),
  'whatsapp/outlined/16': require('./whatsapp/whatsapp-outlined-16.svg'),
  'whatsapp/outlined/20': require('./whatsapp/whatsapp-outlined-20.svg'),
  'windows-close/outlined/20': require('./windows-close/windows-close-outlined-20.svg'),
  'windows-maximize/outlined/20': require('./windows-maximize/windows-maximize-outlined-20.svg'),
  'windows-minimize/outlined/20': require('./windows-minimize/windows-minimize-outlined-20.svg'),
  'windows-unmaximize/outlined/20': require('./windows-unmaximize/windows-unmaximize-outlined-20.svg'),
  'workspace/filled/16': require('./workspace/workspace-filled-16.svg'),
  'workspace/outlined/16': require('./workspace/workspace-outlined-16.svg'),
  'x-circle/filled/12': require('./x-circle/x-circle-filled-12.svg'),
  'x-circle/filled/16': require('./x-circle/x-circle-filled-16.svg'),
  'x-circle/filled/20': require('./x-circle/x-circle-filled-20.svg'),
  'x-circle/outlined/16': require('./x-circle/x-circle-outlined-16.svg'),
  'x-close/outlined/12': require('./x-close/x-close-outlined-12.svg'),
  'x-close/outlined/16': require('./x-close/x-close-outlined-16.svg'),
  'x-close/outlined/20': require('./x-close/x-close-outlined-20.svg'),
});
